import { HttpClient } from '@/shared/lib/http-client';

export const deleteTaskAttachment = async (id) => {
  const response = await HttpClient.delete(`/tasks/attachments/${id}`);

  return response.data?.data;
};
